function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.456.707l9.374 9.374c5.178 5.178 5.178 13.572 0 18.75s-13.571 5.176-18.748 0c-5.178-5.178-5.178-13.572 0-18.75z",
  stroke: "#fff"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.146 23.354a.5.5 0 00.708 0l3.182-3.182a.5.5 0 10-.708-.707L19.5 22.293l-2.828-2.828a.5.5 0 10-.707.707zM19 13v10h1V13z",
  fill: "#fff"
});

var SvgDownIndicator = function SvgDownIndicator(props) {
  return React.createElement("svg", _extends({
    fill: "none",
    height: 39,
    width: 39
  }, props), _ref, _ref2);
};

export default SvgDownIndicator;